
import {css} from "@benev/slate"
export default css`@layer view {

:host {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
}

}`

